import React from 'react'

const React_Coding_Practice_3 = () => {
  return (
    <div>
      <h1>Coding Practice 3</h1>
    </div>
  )
}

export default React_Coding_Practice_3
